export default __webpack_public_path__ + "static/media/bench-window-back-rounded-bottom.ac1c8581.webp";